const groupCount = {}

groupCount.perWeek = (timestamps, values = null) => {
  // timestamps = []
  const weekMap = {}
  const getWeek = date => {
    const onejan = new Date(date.getFullYear(), 0, 1)
    return Math.ceil((((date - onejan) / 86400000) + onejan.getDay() - 1) / 7)
  }
  const getYear = date => {
    return date.getFullYear()
  }
  const getYearWeek = date => {
    const w = getWeek(date)
    const y = getYear(date)
    const weekStr = w < 10 ? `0${w}` : `${w}`
    const key = `${y}${weekStr}`
    return key
  }

  timestamps.forEach((t, index) => {
    const key = getYearWeek(new Date(t))

    if (!weekMap[key]) {
      weekMap[key] = 0
    }

    if (values) {
      weekMap[key] += values[index]
    } else {
      weekMap[key]++
    }
  })

  const firstDate = new Date(timestamps[timestamps.length - 1])
  const lastDate = new Date(timestamps[0])
  let loopDate = firstDate

  while (loopDate <= lastDate) {
    const loopDateKey = getYearWeek(loopDate)

    if (!weekMap[loopDateKey]) {
      weekMap[loopDateKey] = 0
    }
    loopDate = new Date(loopDate.setTime(loopDate.getTime() + 7 * 86400000))
  }

  return weekMap
}

groupCount.perMonth = (timestamps, values = null) => {
  // timestamps = []
  const monthMap = {}
  const getYearWeek = date => {
    const w = date.getMonth() + 1
    const y = date.getFullYear()
    const weekStr = w < 10 ? `0${w}` : `${w}`
    const key = `${y}${weekStr}`
    return key
  }

  timestamps.forEach((t, index) => {
    const w = getYearWeek(new Date(t))

    if (!monthMap[w]) {
      monthMap[w] = 0
    }

    if (values) {
      monthMap[w] += values[index]
    } else {
      monthMap[w]++
    }
  })

  const firstDate = new Date(timestamps[timestamps.length - 1])
  const lastDate = new Date(timestamps[0])
  let loopDate = firstDate

  while (loopDate <= lastDate) {
    const loopDateKey = getYearWeek(loopDate)

    if (!monthMap[loopDateKey]) {
      monthMap[loopDateKey] = 0
    }
    loopDate = new Date(loopDate.setTime(loopDate.getTime() + 7 * 4 * 86400000))
  }

  return monthMap
}

export default groupCount
